import { Container } from 'inversify-props';
import setupHireModule from '@/modules/flagship/strategy-moderate/hire/setup';

export default function setupStrategyModerate(container: Container) {
  setupHireModule(container);
}
